import { useMountStore } from '@/state/useMountStore'
import './ShipHUD.css'  // reuse same styling

export function MountHUD() {
  const mounted = useMountStore((s) => s.mounted)

  if (!mounted) return null

  return (
    <div className="ship-hud">
      <div className="ship-hud__info">
        <div className="ship-hud__name">Horse</div>
      </div>

      <div className="ship-hud__controls">
        <div className="ship-hud__control-group">
          <span className="ship-hud__key">W</span>
          <span className="ship-hud__label">Trot Forward</span>
        </div>
        <div className="ship-hud__control-group">
          <span className="ship-hud__key">S</span>
          <span className="ship-hud__label">Slow / Back</span>
        </div>
        <div className="ship-hud__control-group">
          <span className="ship-hud__key">A / D</span>
          <span className="ship-hud__label">Steer</span>
        </div>
        <div className="ship-hud__control-group">
          <span className="ship-hud__key">Shift</span>
          <span className="ship-hud__label">Gallop</span>
        </div>
        <div className="ship-hud__separator" />
        <div className="ship-hud__control-group">
          <span className="ship-hud__key">F</span>
          <span className="ship-hud__label">Dismount</span>
        </div>
      </div>
    </div>
  )
}
